module.exports = "https://bin.bnbstatic.com/_next/static/images/es5-66cd7acfeaf8b85165ef0fb93ec1aa39.jpg";